var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { content: _vm.tippyLabel },
          expression: "{ content: tippyLabel }"
        }
      ],
      staticClass: "calendar-event v-event-draggable",
      style: "--event-color: " + _vm.status.hexColor,
      attrs: { type: "button" },
      on: {
        mousedown: function($event) {
          $event.stopPropagation()
          return _vm.startDrag(_vm.event)
        },
        click: function($event) {
          $event.stopPropagation()
          return _vm.editDeliverable(_vm.event)
        }
      }
    },
    [
      _c("span", {
        staticClass: "event-status",
        attrs: { "aria-hidden": "true" }
      }),
      _c("span", { staticClass: "event-label no-select" }, [
        _vm._v(_vm._s(_vm.event.name))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }